import * as React from 'react';

export function SvgSpeedXSlow(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        clipRule="evenodd"
        d="m6 13c0-3.31371 2.68629-6 6-6 3.3137 0 6 2.68629 6 6 0 1.6791-.6884 3.1956-1.8009 4.2858-.3945.3865-.4009 1.0196-.0144 1.4141.3866.3945 1.0197.4009 1.4142.0143 1.4806-1.4508 2.4011-3.4759 2.4011-5.7142 0-4.41828-3.5817-8-8-8-4.41828 0-8 3.58172-8 8 0 2.2383.92053 4.2634 2.40112 5.7142.39446.3866 1.02759.3802 1.41414-.0143.38654-.3945.38012-1.0276-.01434-1.4141-1.11252-1.0902-1.80092-2.6067-1.80092-4.2858zm1.89915-1.2548c-.10992-.0841-.26508-.0738-.36292.0241-.10278.1027-.10827.2676-.01256.377l4.14303 4.7348c.3445.3938.9503.414 1.3203.044.3868-.3868.3444-1.0258-.0901-1.3582z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
